import { Badge, Button, Tooltip, Typography } from 'antd';
import React, { memo, useState } from 'react';
import * as VoucherApi from '../../api/voucher/voucherApi';
import './VoucherResultCard.scss'
import useToast from '../../hook/useToast';
import { InfoCircleFilled } from '@ant-design/icons';
import { VoucherDetailStatusEnum } from '../../services/data';
import { formatPrice, getPermissionClass } from '../../until';
const { Text } = Typography;

interface InfoRowDetailProps {
  label: string;
  value: string | undefined;
  total: number | undefined;
  des: string;
}

interface Props {
  dataLoopupVoucher?: VoucherApi.ILoopupVoucher
  edit?: boolean
  ctaClick?: () => void,
}

const VoucherResultCard: React.FC<Props> = (props) => {
  const {
    dataLoopupVoucher,
    edit,
    ctaClick,
  } = props

  const handleClick = () => {
    if (ctaClick) {
      ctaClick()
      // getInfoVoucher(idVoucher)
    }
  }


  const InfoRowDetail = memo(
    ({ label, value, total, des }: InfoRowDetailProps) => {
      const tooltipValue = value?.split(",").map(item => item.trim())

      return (
        total && total > 1 ?
          <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>{label}</span>
            <div className="custom-page-css flex gap-1">
              <span className='custom-page-css font-regular text-sm '>{formatPrice(total)} {des}</span>
              <Tooltip
                placement="right"
                color="white"
                title={
                  <div className="custom-page-css flex flex-col gap-2 p-2 scroll-tooltip-voucher"
                  >
                    {
                      tooltipValue?.map((item, k) => (
                        <div
                          key={k}
                          className=""
                        >
                          <Text strong>{item}</Text>
                        </div>
                      ))
                    }
                  </div>
                }
              >
                <div className="count-number-E6F7FF">
                  <InfoCircleFilled className="info-icon" />
                </div>
              </Tooltip>
            </div>
          </div>
          :
          <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>{label}</span>
            <div className="custom-page-css flex gap-1">
              <span className='custom-page-css font-regular text-sm '>{tooltipValue}</span>
            </div>
          </div>

      );
    }
  );

  const InfoRowDescription = ({ label, value }: { label: string; value?: React.ReactNode }) => (
    <div className="custom-page-css flex justify-between py-1 gap-6" >
      <span className="custom-page-css font-medium text-sm text-344054">{label}</span>

      <div className='custom-page-css flex items-center gap-1'>
        <span className="custom-page-css text-right text-sm text-344054 text-truncate" style={{ width: '300px' }}>{value ?? '—'}</span>

        {value &&
          <Tooltip
            placement="right"
            color="white"
            title={
              <div className="custom-page-css flex flex-col gap-2 p-2 "
              >

                <div
                  className=""
                >
                  <span className="custom-page-css text-sm text-344054" >{value}</span>
                </div>
              </div>
            }
          >
            <div className="count-number-E6F7FF">
              <InfoCircleFilled className="info-icon" />
            </div>
          </Tooltip>
        }
      </div>
    </div>
  );

  return (
    <div className="voucher-result-card">
      <div className="block">
        <div className="title">
          <span>Voucher&nbsp;</span>
          <span className="primary-7">{dataLoopupVoucher?.code}</span>
          <span>&nbsp;thuộc chương trình&nbsp;</span>
          <span className="primary-7">{dataLoopupVoucher?.title}</span>
        </div>
      </div>

      <div className="block">
        <div className="list">
          <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>Đơn vị phát hành</span>
            <span className='custom-page-css font-regular text-sm '>{dataLoopupVoucher?.issuedUnit}</span>

          </div>
          <InfoRowDetail label='Đơn vị áp dụng' value={dataLoopupVoucher?.appliedUnits} total={dataLoopupVoucher?.totalAppliedUnits} des='đơn vị' />

          <InfoRowDetail label='Thương hiệu áp dụng' value={dataLoopupVoucher?.appliedBrands} total={dataLoopupVoucher?.totalAppliedBrands} des='thương hiệu' />

          <InfoRowDetail label='Hoạt động áp dụng' value={dataLoopupVoucher?.appliedActivities} total={dataLoopupVoucher?.totalAppliedActivities} des='hoạt động' />
          <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>Áp dụng cho</span>
            <span className='custom-page-css font-regular text-sm '>{dataLoopupVoucher?.customerName}</span>

          </div>
        </div>
      </div>
      <div className="block">
        <div className="list">
          <div className="item">
            <span className="custom-page-css font-medium text-sm text-344054">Trạng thái</span>
            <Badge
              className="rs-tag daybreak-blue--outlined"
            >{dataLoopupVoucher?.usageText}</Badge>
          </div>
          <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>Hình thức</span>
            <span
              style={{
                color: '#52C41A',
                padding: '2px 8px',
                backgroundColor: '#F6FFED',
                border: '1px solid #B7EB8F',
                borderRadius: 8
              }}
            >{dataLoopupVoucher?.percentDecrease ? 'Giảm theo phần trăm' : 'Giảm số tiền'}</span>
          </div>
          {dataLoopupVoucher?.typeVoucherId === 1 &&
            <div className="item">
              <span className='custom-page-css font-medium text-sm text-344054'>Phần trăm/ Số tiền giảm</span>
              <span className='custom-page-css font-bold text-xl text-F55E09'>{formatPrice(dataLoopupVoucher?.reducedAmount ?? dataLoopupVoucher?.percentDecrease)} {dataLoopupVoucher?.percentDecrease ? '%' : 'đ'}</span>
            </div>
          }

          <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>Giá trị đơn hàng tối thiểu</span>
            <span className='custom-page-css font-bold text-xl text-01498B'>{formatPrice(dataLoopupVoucher?.orderValueMin ?? 0)} đ</span>
          </div>
          {dataLoopupVoucher?.typeVoucherId === 1 &&

            <div className="item">
              <span className='custom-page-css font-medium text-sm text-344054'>Số tiền giảm tối đa</span>
              <span className='custom-page-css font-bold text-xl text-F55E09'>{formatPrice(dataLoopupVoucher?.reducedAmountMaximum ?? 0)} đ</span>
            </div>
          }

          {/* <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>Số lần áp dụng cho mỗi khách hàng</span>
            <span className='custom-page-css font-regular text-sm '>{formatPrice(dataLoopupVoucher?.usageCount)} lần</span>

          </div> */}
          <div className="item">
            <span className='custom-page-css font-medium text-sm text-344054'>Thời gian áp dụng</span>
            <span className='custom-page-css font-regular text-sm '>
              {dataLoopupVoucher?.timeStart} {dataLoopupVoucher?.actualStartTime || dataLoopupVoucher?.dateStart} - {dataLoopupVoucher?.timeEnd} {dataLoopupVoucher?.dateEnd}
            </span>

          </div>
          <InfoRowDescription
            label="Điều kiện"
            value={dataLoopupVoucher?.termsOfUse || ''}
          />
          {dataLoopupVoucher?.isUsedUp &&
            <div className="custom-page-css w-full flex items-center p-2 gap-2 rounded border-FFA39E bg-FFF1F0">
              <InfoCircleFilled className="custom-page-css flex shrink-0 text-FF4D4F" />
              <span className="custom-page-css w-full text-sm text-FF4D4F">Voucher đã đạt giới hạn số lần quy đổi của Voucher theo cấu hình chương trình.</span>
            </div>
          }

          {(dataLoopupVoucher?.status !== VoucherDetailStatusEnum.ACTIVE && dataLoopupVoucher?.status !== VoucherDetailStatusEnum.ENDED) &&
            <div className="custom-page-css w-full flex items-center p-2 gap-2 rounded border-FFA39E bg-FFF1F0">
              <InfoCircleFilled className="custom-page-css flex shrink-0 text-FF4D4F" />
              <span className="custom-page-css w-full text-sm text-FF4D4F">Chương trình Voucher hiện đang tạm ngưng, khách hàng chưa thể thực hiện quy đổi tại thời điểm này.</span>
            </div>
          }
          {dataLoopupVoucher?.status === VoucherDetailStatusEnum.ENDED &&
            <div className="custom-page-css w-full flex items-center p-2 gap-2 rounded border-FFA39E bg-FFF1F0">
              <InfoCircleFilled className="custom-page-css flex shrink-0 text-FF4D4F" />
              <span className="custom-page-css w-full text-sm text-FF4D4F">Voucher này đã hết hiệu lực quy đổi và không thể sử dụng. </span>
            </div>
          }
        </div>
        <div className="block pt-2">
          <div className="item justify-center">
            <Button
                  className={`${getPermissionClass(edit)} `}
              disabled={!dataLoopupVoucher?.hasInvoice || dataLoopupVoucher?.status !== VoucherDetailStatusEnum.ACTIVE || dataLoopupVoucher.isUsedUp}
              type="primary"
              onClick={handleClick}
            >Quy đổi</Button>
          </div>
          {dataLoopupVoucher?.hasInvoice === false &&
            <div className="custom-page-css w-full flex items-center justify-end">
              <div className="custom-page-css flex items-center justify-end p-2 gap-2 rounded border-FFA39E bg-FFF1F0 justify-center mt-2">
                <InfoCircleFilled className="custom-page-css flex shrink-0 text-FF4D4F" />
                <span className="custom-page-css w-full text-sm text-FF4D4F">Khách hàng chưa có hóa đơn liên quan đến chương trình này!</span>
              </div>
            </div>
          }
        </div>
      </div>

    </div>
  );
}

export default VoucherResultCard;
